#import "../../../shared/graphql/fragments/quote-money-fragment.graphql"
#import "../../../shared/graphql/fragments/product-line-item-fragment.graphql"
#import "../../../shared/graphql/fragments/subtotal-line-item-fragment.graphql"

fragment SalesDocumentFragment on SalesDocument {
    __typename
    id
    displayStatus
    statusLog
    displayNumber
    subtotal {
        ...QuoteMoneyFragment
    }
    total {
        ...QuoteMoneyFragment
    }
    slug
    productLineItems {
        ...ProductLineItemFragment
    }
    subtotalLineItems {
        ...SubtotalLineItemFragment
    }
    logo
    preparedTime
    preparedTimeFormatted
    validUntilDate
    validUntilDateFormatted
    creatorUser {
        id
        name
    }
    createdTime
    modifiedTime
    sentTime
    acceptedTime
    revokedTime
    archivedTime
    publishedTime
    headerLeftColumn
    headerRightColumn
    body
    footer
    preparedFor
    preparedBy
    isSkuShown
    isTermShown
    isDiscountShown
    shareableViewInBrowserLink
    lead {
        id
    }
    ... on Invoice {
        purchaseOrderNumber
        customerNumber
        jobNumber
        referenceNumber
        paymentAndTerms
        completionComment
        overdueDuration
    }
}
